import { useEffect } from "react"
import useGlobalStore from "~/store/global"
import {
  clearFilesSessionBounded,
  startFilesSession
} from "~/utils/files-session"

const issuedLinked = new Set<number>()

function currentCtx() {
  const { tokenInfo, linkedTenantId } = useGlobalStore.getState()
  if (!tokenInfo?.token || !tokenInfo.tenant_id || !tokenInfo.user_id)
    return null
  return {
    token: tokenInfo.token,
    tenantId: Number(tokenInfo.tenant_id),
    userId: Number(tokenInfo.user_id),
    linkedTenantId: linkedTenantId || null
  }
}

export function useFilesSession() {
  const token = useGlobalStore((s) => s.tokenInfo?.token)
  const tenantId = useGlobalStore((s) => s.tokenInfo?.tenant_id)
  const linkedTenantId = useGlobalStore((s) => s.linkedTenantId)
  useEffect(() => {
    if (!token) return
    if (linkedTenantId) issuedLinked.add(Number(linkedTenantId))
    return startFilesSession(currentCtx)
  }, [token, tenantId, linkedTenantId])
}

export async function clearFilesCookies() {
  const ctx = currentCtx()
  const linked = ctx
    ? [...issuedLinked].filter((id) => id !== Number(ctx.linkedTenantId))
    : []
  issuedLinked.clear()
  await Promise.all([
    clearFilesSessionBounded(ctx),
    ...linked.map((id) =>
      clearFilesSessionBounded(ctx && { ...ctx, linkedTenantId: id })
    )
  ])
}
